import type { SupportMailRequest } from "./supportSharePort.js";

export const SUPPORT_EMAIL = "helpyjs@gmail.com";
export const SUPPORT_APP_NAME = "idle brick";

export interface BuildSupportMailInput {
  readonly version: string;
  readonly platform: string;
  readonly body: string;
  readonly logContent: string;
  readonly nowMs: number;
}

export function buildSupportSubject(version: string, platform: string): string {
  return `[${SUPPORT_APP_NAME} v${version}-${platform} 문의]`;
}

export function buildSupportMail(input: BuildSupportMailInput): SupportMailRequest {
  return {
    subject: buildSupportSubject(input.version, input.platform),
    body: input.body,
    logContent: input.logContent,
    logFileName: `support-${input.nowMs}.log`,
  };
}
